<template>
	<div class="footBox">
		<div class="footBox2">
			<img src="@/images/footBox_icon.png" class="footBox_icon"/>
			<div class="footBox_name">
				技术支持单位：<img src="@/images/footBox_name.png"/>山东中飞科技有限公司
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'footmain',
		data() {
			return {

			}
		},
		created() {

		},
		mounted() {

		},
		methods: {

		},
	}
</script>